import {AnimatePresence, motion} from "framer-motion";
import {FC, useState} from "react";
import {Button} from "../../ui-components/button.tsx";
import {Heading} from "../../ui-components/heading.tsx";
import {ModalPropsType} from "../../context/ModalContext.tsx";
import {CustomSwitcher} from "../CustomSwitcher.tsx";
import {useTranslation} from "react-i18next";

export const WarningModal: FC<ModalPropsType> = ({isOpen, onClose, onConfirm}) => {
    const [isRefCodeExist, setIsRefCodeExist] = useState(false);
    const onChangeRefCodeExist = () => {
        setIsRefCodeExist(!isRefCodeExist)
    }
    const {t} = useTranslation()

    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <div className="absolute inset-0 bg-black/50 flex items-end justify-center z-[99999]"
                         onClick={onClose}>
                        <motion.div
                            initial={{y: "100%", opacity: 0}}
                            animate={{y: 0, opacity: 1}}
                            exit={{y: "100vh", opacity: 0}} // Уезжает вниз при закрытии
                            transition={{duration: 0.4, ease: "easeInOut"}}
                            className="bg-white rounded-t-xl w-full px-4.5 pt-6 pb-8 shadow-lg flex flex-col"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Heading level={2} className={"text-2xl text-center mb-4"}>
                                {t('modals.deleteChannel.heading')}
                            </Heading>
                            <p className="!text-sm text-center text-[var(--color-secondary-2)] mb-6">
                                {t('modals.deleteChannel.subTitle')}
                            </p>
                            <div className={"px-3 pb-6"}>
                                <CustomSwitcher onChangeAction={onChangeRefCodeExist}
                                                value={isRefCodeExist}
                                                label={t('modals.deleteChannel.conditionsTitle')}/>
                            </div>
                            <div className="flex gap-6">
                                <Button color={"white"}
                                        className="w-full !bg-white !py-2.5 rounded-lg !border !border-[var(--btn-border-custom)] shadow-xs !text-sm !leading-5"
                                        onClick={onClose}>
                                    {t('common.buttons.cancel')}
                                </Button>
                                <Button color={"cyan"}
                                        disabled={!isRefCodeExist}
                                        onClick={() => {
                                            if (onConfirm) {
                                                onConfirm()
                                            }
                                            onClose()
                                        }}
                                        className="w-full !py-2.5 rounded-lg !bg-[var(--color-red)] before:bg-transparent text-white !text-sm !leading-5">
                                    {t('common.buttons.deleteBtn')}
                                </Button>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </>
    )
}
